/* [Modified by Codex at 2026-09-11] 延迟加载非首屏合集标签并恢复商品卡交互 */
(() => {
  const responseCache = new Map();
  const sectionSelector = '[data-type="product_grid"] .bls__collection-tab';

  class VedressCollectionTabLazy {
    constructor(element) {
      this.element = element;
      if (element.dataset.vedressLazyBound === "true") return;

      this.element.dataset.vedressLazyBound = "true";
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleChange = this.handleChange.bind(this);

      this.element.addEventListener("click", this.handleClick);
      this.element.addEventListener("keydown", this.handleKeydown);
      this.element.addEventListener("change", this.handleChange);
    }

    handleClick(event) {
      const tab = event.target.closest(".bls__collection-tab-item");
      if (!tab || !this.element.contains(tab)) return;

      this.activate(tab.dataset.id);
    }

    handleKeydown(event) {
      if (event.key !== "Enter" && event.key !== " ") return;

      const tab = event.target.closest(".bls__collection-tab-item");
      if (!tab || !this.element.contains(tab)) return;

      event.preventDefault();
      this.activate(tab.dataset.id);
    }

    handleChange(event) {
      if (!event.target.matches(".select-data")) return;

      this.activate(event.target.value);
    }

    activate(tabId) {
      if (!tabId) return;

      this.element.querySelectorAll(".bls__collection-tab-item").forEach((tab) => {
        const active = tab.dataset.id === tabId;
        tab.classList.toggle("active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });

      this.element.querySelectorAll(".bls__cls-tab").forEach((panel) => {
        panel.classList.toggle("active", panel.id === tabId);
      });

      const panel = Array.from(this.element.querySelectorAll(".bls__cls-tab")).find(
        (item) => item.id === tabId,
      );
      if (panel?.dataset.lazyLoaded === "false") {
        this.load(panel);
      }
    }

    async load(panel) {
      if (panel.vedressLoadingPromise) return panel.vedressLoadingPromise;

      const url = panel.dataset.lazyUrl;
      const status = panel.querySelector(".vedress-tab-lazy-status");
      if (!url || !status) return;

      panel.classList.add("is-loading");
      panel.setAttribute("aria-busy", "true");
      status.hidden = false;

      panel.vedressLoadingPromise = this.fetchMarkup(url)
        .then((markup) => {
          const documentFragment = new DOMParser().parseFromString(markup, "text/html");
          const source = documentFragment.querySelector(".vedress-lazy-products");
          if (!source) throw new Error("Lazy product response is missing its content wrapper.");

          panel.vedressProducts = Array.from(source.querySelectorAll(":scope > .vedress-lazy-product"));
          panel.vedressCursor = 0;
          panel.dataset.lazyLoaded = "true";
          this.appendNextBatch(panel);

          if (panel.vedressProducts.length === 0) {
            this.showFallback(panel, "No products found.");
          } else {
            status.hidden = true;
          }
        })
        .catch((error) => {
          console.error("Unable to load collection tab products:", error);
          this.showFallback(panel, "Unable to load products.");
        })
        .finally(() => {
          panel.classList.remove("is-loading");
          panel.removeAttribute("aria-busy");
          panel.vedressLoadingPromise = null;
        });

      return panel.vedressLoadingPromise;
    }

    fetchMarkup(url) {
      if (!responseCache.has(url)) {
        responseCache.set(
          url,
          fetch(url, {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
          }).then((response) => {
            if (!response.ok) throw new Error(`Request failed with status ${response.status}.`);
            return response.text();
          }),
        );
      }

      return responseCache.get(url);
    }

    appendNextBatch(panel) {
      const grid = panel.querySelector('[id^="bls__product-grid-"]');
      const products = panel.vedressProducts || [];
      const limit = Number.parseInt(panel.dataset.lazyLimit, 10) || products.length;
      const batch = Number.parseInt(panel.dataset.lazyBatch, 10) || limit;
      const start = panel.vedressCursor || 0;
      const end = Math.min(start + batch, limit, products.length);

      if (!grid || start >= end) {
        this.updateAction(panel);
        return;
      }

      const fragment = document.createDocumentFragment();
      products.slice(start, end).forEach((product) => fragment.appendChild(product));
      grid.appendChild(fragment);
      panel.vedressCursor = end;

      this.initializeProductCards(grid);
      this.updateAction(panel);
    }

    updateAction(panel) {
      panel.querySelector(".vedress-tab-lazy-action")?.remove();
      if (panel.dataset.lazyLoadMore !== "true") return;

      const fallbackUrl = panel.dataset.lazyFallbackUrl;
      const action = document.createElement("div");
      const buttonType = panel.dataset.lazyButtonType || "primary";
      const buttonLabel = panel.dataset.lazyButtonLabel || "View collection";
      action.className = "vedress-tab-lazy-action bls__load-more text-center";

      if (panel.dataset.lazyButtonAction === "redirect") {
        const link = document.createElement("a");
        link.className = `btn-${buttonType}`;
        link.href = fallbackUrl;
        link.textContent = buttonLabel;
        action.appendChild(link);
      } else {
        const limit = Number.parseInt(panel.dataset.lazyLimit, 10) || 0;
        const available = Math.min(limit, panel.vedressProducts?.length || 0);
        if ((panel.vedressCursor || 0) >= available) return;

        const button = document.createElement("button");
        button.type = "button";
        button.className = `bls__btn-load-more btn-${buttonType}`;
        button.textContent = buttonLabel;
        button.addEventListener("click", () => this.appendNextBatch(panel), { once: true });
        action.appendChild(button);
      }

      panel.appendChild(action);
    }

    showFallback(panel, message) {
      const status = panel.querySelector(".vedress-tab-lazy-status");
      if (!status) return;

      status.hidden = false;
      status.querySelector(".loader-icon")?.remove();
      const messageElement = status.querySelector(".vedress-tab-lazy-message");
      if (messageElement) messageElement.textContent = message;

      const fallbackUrl = panel.dataset.lazyFallbackUrl;
      if (fallbackUrl && !status.querySelector("a")) {
        const link = document.createElement("a");
        link.href = fallbackUrl;
        link.textContent = panel.dataset.lazyButtonLabel || "View collection";
        status.appendChild(link);
      }
    }

    initializeProductCards(root) {
      this.initializeLazyImages(root);

      if (window.BlsColorSwatchesShopify) {
        root.querySelectorAll(".bls__product-color-swatches").forEach((swatch) => {
          window.BlsColorSwatchesShopify.checkSwatches(swatch);
        });

        root
          .querySelectorAll(".bls__option-swatch-js,.bls__product-compare,.bls__product-wishlist")
          .forEach((control) => {
            if (control.dataset.vedressSwatchBound === "true") return;
            const product = control.closest(".bls__product-item");
            if (!product) return;

            control.dataset.vedressSwatchBound = "true";
            let tooltipTimer;
            control.addEventListener("mouseout", () => {
              const swiper = control.closest(".swiper");
              if (!swiper) return;
              tooltipTimer = window.setTimeout(() => swiper.classList.remove("show-tooltip"), 400);
            });
            control.addEventListener("mouseover", () => {
              window.clearTimeout(tooltipTimer);
              window.BlsColorSwatchesShopify.listenerColor(control, product);
              control.closest(".swiper")?.classList.add("show-tooltip");
            });
          });
      }

      if (window.BlsSubActionProduct) {
        root.querySelectorAll(".bls__product-quickview").forEach((button) => {
          if (button.dataset.vedressQuickviewBound === "true") return;
          button.dataset.vedressQuickviewBound = "true";
          button.addEventListener("click", () => {
            button.classList.add("btn-loading");
            const product = button.closest(".bls__product-item");
            if (product?.dataset.productHandle) {
              window.BlsSubActionProduct.handleFetchDataQuickView(button, product.dataset.productHandle);
            }
          });
        });

        root.querySelectorAll(".bls__product-wishlist-js").forEach((button) => {
          if (button.dataset.vedressWishlistBound === "true") return;
          button.dataset.vedressWishlistBound = "true";
          button.addEventListener("click", window.BlsSubActionProduct.handleWishlistFunctionClick);
        });

        root.querySelectorAll(".bls__product-compare-js").forEach((button) => {
          if (button.dataset.vedressCompareBound === "true") return;
          button.dataset.vedressCompareBound = "true";
          button.addEventListener("click", window.BlsSubActionProduct.handleCompareFunctionClick);
        });

        window.BlsSubActionProduct.handleInitWishlist();
        window.BlsSubActionProduct.handleInitCompare();
      }

      window.BlsReloadSpr?.init();
    }

    initializeLazyImages(root) {
      /* [Modified by Codex at 2026-09-14] 动态商品复用全站唯一图片观察器 */
      if (window.BlsLazyloadImg?.init) {
        window.BlsLazyloadImg.init(root);
        return;
      }
      /* [End] */

      const images = root.querySelectorAll(".bls-image-js img:not([data-vedress-lazy-bound])");
      if (!("IntersectionObserver" in window)) {
        images.forEach((image) => image.classList.add("bls-loaded-image"));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, imageObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            image.width = entry.boundingClientRect.width;
            image.height = entry.boundingClientRect.height;
            image.sizes = `${entry.boundingClientRect.width}px`;
            image.classList.add("bls-loaded-image");
            image.closest(".bls-image-js")?.classList.remove("bls-loading-image");
            imageObserver.unobserve(image);
          });
        },
        { rootMargin: "100px" },
      );

      images.forEach((image) => {
        image.dataset.vedressLazyBound = "true";
        observer.observe(image);
      });
    }
  }

  const initialize = (scope = document) => {
    if (scope.matches?.(sectionSelector)) new VedressCollectionTabLazy(scope);
    scope.querySelectorAll?.(sectionSelector).forEach((element) => {
      new VedressCollectionTabLazy(element);
    });
  };

  initialize();
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const component = event.target.querySelector?.(".bls__collection-tab");
    if (!component) return;
    const instance = new VedressCollectionTabLazy(component);
    instance.activate?.(`collection-${event.detail.blockId}`);
  });
})();
/* [End] */
